import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect,Link } from 'react-router-dom';
import {format} from 'date-fns';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {format as stringFormat} from 'react-string-format';
import {userGroupUrlCheck,getUserTimeZone} from '../../utils/userGroupUrlCheck';
import { LM_AFLT_QUOTES,LM_AFLT_EVENTS } from '../../configs/menuNamesConfigs'; 
import { LBL_DESCENDING_ORDER,LBL_ASCENDING_ORDER,LBL_SORT_BY_HOURS,LBL_SORT_BY_CREW,LBL_WORKING_HRS_DESC, LBL_CREW,LBL_CREWS,LBL_APP_NAME, LBL_SCHEDULE_SHIFT,LBL_HOURS_SHORT,LBL_CLEAR_FILTERS, LBL_ACTIVE_SHIFTS, LBL_TO, LBL_AFFILIATE_POOL, LBL_OMNU_POOL, LBL_SHIFTS,LBL_SCHEDULE_SHIFT_FIND_CREW, LBL_CONFIRMED, LBL_REQUESTED,  LBL_REQUIRED, LBL_TOTAL,LBL_CHIEF, LBL_CHIEF_S, LBL_MULTI_SHIFT, LBL_ALL_COMMON_SKILLS, LBL_UNALLOCATED_SHIFT, LBL_WITHIN_30_DAYS} from '../../configs/labelConfigs';  
import {ROUTE_REFRESH, ROUTE_AFFILIATE_REFRESH, SCROLL_PAGING_COUNT_AFFILIATE,LOGIN_AFFILIATE_GROUP, LOGIN_CLIENT_GROUP,RANDOM_COLORS,CREW_MAX_RATING,ROUTE_AFFILIATE_QUOTES,ROUTE_AFFILIATE_EVENTS,ROUTE_AFFILIATE_SHIFT,UNALLOCATED_SHIFTS_COUNT_DAYS, SHIFT_STAFF_REQ_ERR_UNAVAIL, SHIFT_STAFF_REQ_ERR_REQUESTED, SHIFT_STAFF_REQ_ERR_FILLED, SHIFT_STAFF_REQ_ERR_SKILL_FILLED, SHIFT_STAFF_REQ_ERR_CHEIF_FILLED, SHIFT_STAFF_REQ_ERR_CHEIF_SKILL_FILLED, SHIFT_STAFF_REQ_ERR_DEPT_MISMATCH} from '../../configs/staticConfigs';
import {MSG_CREW_SHIFT_TIME_OVERLAP,MSG_CREW_SHIFT_NOT_FOUND,MSG_CREW_SHIFT_NO_COMMON_SKILLS,MSG_PAST_SHIFT_SCHEDULE,MSG_CREW_UNAVAILABLE,MSG_CREW_REQUESTED,MSG_CREW_FILLED,MSG_CREW_SKILL_FILLED,MSG_CHIEF_FILLED,MSG_CHIEF_SKILL_FILLED, MSG_SHIFT_CREW_DEPT_MISMATCH} from '../../configs/msgConfigs';
import {URL_IMG} from '../../configs/urlConfigs';

import {converDateToLocal,convertDecimalToHHMM} from '../../utils/commonUtilities';  
import {checkPermissions} from '../../utils/permissions'; 
import {shiftScheduleListAction,shiftScheduleCrewAction,shiftScheduleCrewRequestAction,clearShiftIdsForScheduleAction,scheduleShiftCrewAction,getUnallocatedShiftsCountAction} from '../../actions/eventActions';
import { menuActiveAction } from '../../actions/commonActions'; 
import * as types from '../../actions';
import Filter from '../commons/helpers/filterBy';
import Toast from '../commons/helpers/toast';

import ShiftDetailSlider from './shiftDetailSlider';
import {showAddCrewBtn,eventRouteRedirect} from './eventStatusCheck';
import FilterSchedule from './filters/filterSchedule';

const MSG_DEFAULT_CREW_LIST = "nocrews";
class Schedule extends Component {
    constructor(props){
        super()
        this.state = {  
            selectedShiftIds:[],
            selectedShiftList:[],
            skills:[],
            crewProfileId:0,
            shiftList:[],
            showOnlyChief:0,
            perPageCount: SCROLL_PAGING_COUNT_AFFILIATE,
            activePage:1,
            allChecked:false,
            activeShiftId:0,
            hasMore:false,
            crewList:[],
            skillList:[],
            isFindCrewActive:false,
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true, 
            activeRowId:0, 
            findCrewClick:false,
            shiftSearch:'',
            errorMessage:MSG_DEFAULT_CREW_LIST,
            rand :Math.floor(Math.random()*RANDOM_COLORS.length),
            showAddCrewButton:false,
            searchCrew:'',
            totalCrewCount:0,
            selectedSkill:0,
            isFilterOn: false,
            filterClicked: 0,
            resetFilterClicked: 0,
            applyFilterClicked: 0,
            dptClicked:0,
            applyFilter: 0,           
            ratingFrom:'', 
            ratingTo:'', 
            payLevel:[], 
            pointFrom:'', 
            pointTo:'',
            departments:[],
            pageNumber:0,
            multi_shift: 0,
            omnu_pool:0,
            unallocatedShifts: 0,
            ascending:true,
            sortBy:'hours',
            hasVehicle:''
        }
        this.onSearchShift = this.onSearchShift.bind(this);   
        this.onSearchCrew = this.onSearchCrew.bind(this);   
        this.onHandleCheckedShift = this.onHandleCheckedShift.bind(this);

        this.modal = React.createRef(); 
    }   

    onSortToggle = (flag) =>{
      let {ascending} = this.state;
      ascending = flag;
      this.setState({ascending:ascending},() =>{
        this.findCrew()
      });
   }

    onHandleCheckedShift = (e,shift)=>{
        const {selectedShiftList,selectedShiftIds} = this.state;
        if(e.target.checked) {   
            if((shift.pending>0 && shift.required > 0)){     // if shift total pending count > 0 enable the shift checkbox selection
                let dateTime = [];
                dateTime.push(shift.start_datetime,shift.end_datetime);
                let isAddSchedule = checkPermissions("schedule","modify");
                selectedShiftList.push({
                    shift:shift.shift_id,
                    dateTime:dateTime,                
                    isDisableAddCrewBtn:isAddSchedule ? showAddCrewBtn(shift.status) : false, // to show/hide add crew button based on shift status
                    depts:shift.department_id!==null?shift.department_id:''
                }); 
                let shiftIds     = selectedShiftList.map(({ shift }) => shift);
                let dptIds       = selectedShiftList.map(({ depts }) => depts).filter(d=>d!=='');                
               
                this.setState({crewList:[],errorMessage:MSG_DEFAULT_CREW_LIST,isFindCrewActive:true,findCrewClick:false,hasMore:false,selectedShiftIds:shiftIds,totalCrewCount:0,selectedSkill:0,departments:dptIds,multi_shift:(shiftIds && shiftIds.length > 1)?1:0});  
            }
        }else {  // remove unchecked shifts from above created array  
            selectedShiftList.splice(selectedShiftList.findIndex(e => e.shift === shift.shift_id),1); 
            if(selectedShiftList.length===0){ // if all shifts checkbox are unchecked, reset the state
                this.setState({crewList:[],skillList:[],isFindCrewActive:false,findCrewClick:false,hasMore:false,selectedShiftIds:[],errorMessage:MSG_DEFAULT_CREW_LIST,allChecked:false,totalCrewCount:0,selectedSkill:0,departments:[],applyFilter:0,multi_shift:0});                
            }else{         // update the state with remaining checked shift
                let shiftIds     =  selectedShiftIds.filter(s => s !== shift.shift_id); 
                let dptIds       = selectedShiftList.map(({ depts }) => depts).filter(d=>d!=='');
                this.setState({crewList:[],selectedShiftIds:shiftIds,errorMessage:MSG_DEFAULT_CREW_LIST,allChecked:false,totalCrewCount:0,selectedSkill:0,departments:dptIds,multi_shift:(shiftIds && shiftIds.length > 1)?1:0}); 
            }
        }
        let dptClicked = this.state.dptClicked+1; 
        this.setState({dptClicked}, () => {
            this.findCrew(); 
        }); 
    }

    disableAddCrewButton = ()=>{ //disable add crew button if shift status is Confirmed or On Going
        const {selectedShiftList} = this.state;
        let hasDisable = selectedShiftList.some((item) => {          
            return !item.isDisableAddCrewBtn;
        });
        return hasDisable; 
    }
    
    findCrew = () =>{
        const {selectedShiftList,showOnlyChief,perPageCount,selectedShiftIds,searchCrew,selectedSkill,ratingFrom,ratingTo,payLevel,pointFrom,pointTo,departments,applyFilter,sortBy,ascending,hasVehicle} = this.state;       
        let dateTimes    = selectedShiftList.map(({ dateTime }) => dateTime);
        let sort_by = ascending?sortBy:'-'+sortBy
        let isDateLessThanPresent = this.checkDateTimeLessThanPresent(dateTimes);
        let isDateTimeOverlap     = this.checkDateTimeOverlap(dateTimes);
        if(!isDateTimeOverlap){
            if(!isDateLessThanPresent){
                if( selectedShiftIds.length>0 ){  
                    let showAddCrewBtn = this.disableAddCrewButton();   

                    this.props.scheduleShiftCrewAction({hasVehicle:hasVehicle,sortBy:sort_by,shifts:selectedShiftIds,page:1,pageSize:perPageCount,crewName:searchCrew,filter:applyFilter,ratingFrom:ratingFrom,ratingTo:ratingTo,pointFrom:pointFrom,pointTo:pointTo,payLevel:payLevel,departments:departments,selectedSkill:selectedSkill,showOnlyChief:showOnlyChief,multi_shift:this.state.multi_shift,omnu_pool:this.state.omnu_pool}); 

                    this.setState({selectedShiftIds:selectedShiftIds,hasMore:false,activePage:1,findCrewClick:true,showAddCrewButton:!showAddCrewBtn});    

                } else if(selectedShiftIds.length>0){
                    this.setState({crewList:[],skillList:[],errorMessage:MSG_CREW_SHIFT_NO_COMMON_SKILLS,hasMore:false});
                } 
                else if(selectedShiftIds.length===0){   
                    this.setState({crewList:[],errorMessage:LBL_SCHEDULE_SHIFT_FIND_CREW,hasMore:false});    
                } 
            }else{
                this.setState({crewList:[], errorMessage:MSG_PAST_SHIFT_SCHEDULE,hasMore:false});
            } 
        }else{
            this.setState({crewList:[], skillList:[], errorMessage:MSG_CREW_SHIFT_TIME_OVERLAP,hasMore:false});
        }           
    } 

    findMoreCrew =(fromAddCrew) =>{ // pagination
        const {
            ascending,sortBy,activePage,selectedShiftIds,showOnlyChief,perPageCount,searchCrew,selectedSkill,ratingFrom,ratingTo,payLevel,pointFrom,pointTo,departments,applyFilter          
        } = this.state 
        let nextPage = activePage+1;
        if(fromAddCrew){ //to fetch again to fill the removed crew postion
            nextPage = activePage;
        }
        let currentPageSize = perPageCount*nextPage;
        let sort_by = ascending?sortBy:'-'+sortBy

        let dataObj = {sortBy:sort_by,shifts:selectedShiftIds,page:1,pageSize:currentPageSize,crewName:searchCrew,filter:applyFilter,ratingFrom:ratingFrom,ratingTo:ratingTo,pointFrom:pointFrom,pointTo:pointTo,payLevel:payLevel,departments:departments,selectedSkill:selectedSkill,showOnlyChief:showOnlyChief,multi_shift:this.state.multi_shift, omnu_pool:this.state.omnu_pool};  
        
        this.props.scheduleShiftCrewAction(dataObj);
        
        this.setState({activePage: nextPage}); 
    }

    onHandleAllChecked = (e)=>{ // all shifts checkbox selection
        const {shiftList} = this.state;
        let selectedShiftList = [];
        let isAddSchedule = checkPermissions("schedule","modify");
        if(e.target.checked){
            if(shiftList.length>0) {  // loop all shifts and create array for all shift's checkbox selection
                shiftList.forEach(item => {
                    if(item.pending>0 && item.required>0){ // *start* same code as onHandleCheckedShift
                        let dateTime = [];
                        dateTime.push(item.start_datetime,item.end_datetime);
                        selectedShiftList.push({
                            shift:item.shift_id,
                            dateTime:dateTime,                           
                            isDisableAddCrewBtn:isAddSchedule?showAddCrewBtn(item.status) : false,
                            depts:item.department_id!==null?item.department_id:''
                        });
                    }
                });
                let shiftIds     = selectedShiftList.map(function(item) { return item.shift; });
                let dptIds       = selectedShiftList.map(({ depts }) => depts).filter(d=>d!=='');
            
                this.setState({selectedShiftList,isFindCrewActive:true,allChecked:e.target.checked,selectedShiftIds:shiftIds,crewList:[],hasMore:false,errorMessage:MSG_DEFAULT_CREW_LIST,departments:dptIds,selectedSkill:0,multi_shift:1}, () => {
                    this.findCrew(); 
                });            
            }                   
        }else{
            this.setState({isFindCrewActive:false,selectedShiftList:[],allChecked:e.target.checked,selectedShiftIds:[],crewList:[],errorMessage:MSG_DEFAULT_CREW_LIST,hasMore:false,departments:[],applyFilter:0,selectedSkill:0,skillList:[],multi_shift:1});  
        }
        let dptClicked = this.state.dptClicked+1; 
        this.setState({dptClicked}); 
    }

    applyFilters = (filtersData) => {
        const {
            selectedShiftIds        
        } = this.state; 
        let filterApplied = 1;    
        if(selectedShiftIds.length>0){     
            this.setState({
                applyFilter:filterApplied,
                ratingFrom:filtersData.ratingFrom, 
                ratingTo:filtersData.ratingTo, 
                payLevel:filtersData.payLevel, 
                pointFrom:filtersData.pointFrom, 
                pointTo:filtersData.pointTo,
                departments:filtersData.departments,
                hasVehicle:filtersData.has_vehicle
                }, () => { 
                    this.findCrew();                
            }); 
        }                
    }

    onApplyFilterButton = () => {
        let applyFilterClicked = this.state.applyFilterClicked+1; 
        this.setState({applyFilterClicked}); 
    }

    onResetFiltersButton = () => {    
        let {selectedShiftList}  = this.state;
        let resetFilterClicked = this.state.resetFilterClicked+1; 
        let dptIds = selectedShiftList.map(({ depts }) => depts).filter(d=>d!=='');

        if(this.state.applyFilter > 0) {
            this.setState({resetFilterClicked,applyFilter:0,departments:dptIds}, () => {               
                this.findCrew();
                if(this.state.isFilterOn) {
                    document.getElementById("filterIcon").classList.add('active');   
                }else if(!this.state.isFilterOn) {
                    document.getElementById("filterIcon").classList.remove('active');   
                }
            });
        }else {
            this.setState({resetFilterClicked,applyFilter:0}); 
        }
    } 

    onShowActionButtons = (event, rowId) =>{
        let dropdown     = document.getElementById('dropdown-event-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-event-'+rowId);
        dropdown.classList.toggle('show');
        dropdownMenu.classList.toggle('show');      
  
        if(this.state.activeRowId===0){   
            this.setState({activeRowId:rowId}); 
        }else if(this.state.activeRowId===rowId){ 
            this.setState({activeRowId:0}); 
        }else if(this.state.activeRowId!==rowId){   
            dropdown     = document.getElementById('dropdown-event-'+this.state.activeRowId);
            dropdownMenu = document.getElementById('dropdown-menu-event-'+this.state.activeRowId);
            dropdown.classList.toggle('show');
            dropdownMenu.classList.toggle('show');
            this.setState({activeRowId:rowId}); 
        }        
    } 

    onHideActionButtons = (event, rowId) =>{
        let dropdown     = document.getElementById('dropdown-event-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-event-'+rowId);
        dropdown.classList.remove('show');
        dropdownMenu.classList.remove('show');
        this.setState({activeRowId:0});
    }


    // WHEN SHIFT DETAILS SLIDER INVOKED FROM THIS PAGE AND SCHEDULE OPTION CALLED FROM SHIFT DETAILS SLIDER 
    loadEventSchedule = (eventId,shiftDetails) => { 
        let shiftFld = document.getElementById('check'+shiftDetails.shift_id); 
        if(!shiftFld.checked) {
            shiftFld.click(); 
        }
    }

    // CLICK ON MULTI SHIFT CHECK BOX 
    changeMultiSkill = (e) => {
        this.setState({multi_shift:e.target.checked?1:0}); 
    }

    gotoEvents = (eventRoute,eventId) => { 
        if(eventRoute==ROUTE_AFFILIATE_QUOTES)  this.props.menuActiveAction(LM_AFLT_QUOTES);  
        else if(eventRoute==ROUTE_AFFILIATE_EVENTS)  this.props.menuActiveAction(LM_AFLT_EVENTS); 
        this.props.history.push(eventRoute+'/'+eventId);
    }

    onChangePool = (e, option) =>{
        this.setState({omnu_pool:parseInt(option)}, () => this.findCrew());
    }

    onSkillChange = (e) =>{ // call schedule API changing the skill from common skill dropdown
        let isChief = Number(e.target[e.target.selectedIndex].getAttribute('data-chief')); 
        this.setState({ selectedSkill:Number(e.target.value),showOnlyChief:isChief}, () => this.findCrew());
    }

    onSearchShift = (e)=>{ // search shifts in left side
        const {shiftScheduleData} = this.props;  
        this.setState({ shiftList: shiftScheduleData.shift_set.filter(str => str.title.toLowerCase().includes(e.target.value.toLowerCase())),shiftSearch:e.target.value.toLowerCase()})
    }

    onSearchCrew = (e)=>{  // search crews from find crew result
        let {selectedShiftIds,findCrewClick} = this.state;
        if(selectedShiftIds.length>0 && findCrewClick){
            //if(e.target.value.length>2){
                this.setState({ searchCrew:e.target.value }, () => this.findCrew());
            //}
        }else{
            this.setState({searchCrew:e.target.value});
        }
    }

    checkDateTimeOverlap = (dateTimes)=>{ // for selected shift's date overlap check
        let isOverlap = false;
        dateTimes.forEach((time,i) => {
            let  st1 = time[0];
            let  et1 = time[1];
            dateTimes.forEach((time2,j) => {               
                if(i !== j){
                    let st2 = time2[0];
                    let et2 = time2[1];
                    if ( ((st1 >= st2) && (st1 <= et2)) || ((et1 >= st2) && (et1 <= et2)) || ((st2 >= st1) && (st2 <= et1)) || ((et2 >= st1) && (et2 <= et1)) ) {
                        isOverlap =  true;
                        return isOverlap;
                    } 
                }
            })
        }); 
        return isOverlap;
    }

    checkDateTimeLessThanPresent = (dateTimes)=>{ // check selected shift's date is past
        let isLessPresent = false;
        const today = format(new Date(), 'yyyyMMddHHmm')
        dateTimes.forEach((time,i) => {           
            let  startDate = format( new Date(time[1]), 'yyyyMMddHHmm');
            if (startDate < today){
                isLessPresent =  true;
            }
        });
        return isLessPresent;
    }

    dropdownSkills = () =>{ // build skills array for common skills dropdown
        let skillItems  = this.state.skillList; 
        let allSkills   = [];
        let userGroupData = userGroupUrlCheck(this.props.location);
        let lblChief = ''; 
        if(userGroupData!==undefined){
            lblChief = userGroupData.supervisor_name;
        }
        if(Array.isArray(skillItems) && skillItems.length>0){ 
            skillItems.forEach((sk,index1) =>{ //{"skill_id":1306,"skill_name":"General","is_chief":false}
                allSkills.push({
                    id:sk.skill_id,
                    name:sk.is_chief ? lblChief+' - '+sk.skill_name : sk.skill_name, 
                    isChief:sk.is_chief ? 1 : 0, 
                });
            })
        }
        return allSkills;
    }

    openSkillModal= (e,skills,crewProfileId) => {
        this.setState({skills:skills,crewProfileId:crewProfileId});
        // this.modal.current.handleOpenModal();
    }

    sendRequestToCrew = (e,skillId,crewProfileId,isCrewChief)=>{
        let {selectedShiftIds,selectedShiftList} = this.state;  
        let selectedShifts = [];
        selectedShiftIds.forEach(shift=>{ // for each selected shifts 
            selectedShifts.push({shift_id:shift});
        })
        let data =  {
            "shifts": selectedShifts, 
            "skill": skillId, 
            "crew_profile_id": crewProfileId, 
            "multi_shift": this.state.multi_shift, 
            "is_crew_chief": isCrewChief ? true : false,
            "omnu_pool" : this.state.omnu_pool ? this.state.omnu_pool : 0
        };
        this.props.shiftScheduleCrewRequestAction(data);
    }  

    showShiftDetail = (shiftId) =>{
        if(this.state.isFilterOn){
            this.inputFilter.click();
        }
        this.setState({activeShiftId:0},()=>{
            this.setState({activeShiftId:shiftId})
            document.getElementById("filterByMenu").classList.toggle('active');    
            let filterByMenu = document.getElementById('filterByMenu');  
            let quoteTab = document.getElementById('detailTab');
            let filterTab = document.getElementById('filterTab');
            quoteTab.style.display = 'block';    
            filterTab.style.display = 'none';
            filterByMenu.style.width='1100px';
            filterByMenu.style.right='0';
        });
    }

    onShowFilterBy = () => {
        let filterClicked = (this.state.filterClicked+1);
        this.setState(prevState => ({ isFilterOn: !prevState.isFilterOn, filterClicked:filterClicked }));
        document.getElementById("filterByMenu").classList.toggle('active');      
        document.getElementById("filterIcon").classList.toggle('active');   
        let filterByMenu = document.getElementById('filterByMenu');    
        let quoteTab = document.getElementById('detailTab');
        let filterTab = document.getElementById('filterTab');
        quoteTab.style.display = 'none';    
        filterTab.style.display = 'block';        
        if(this.state.isFilterOn){
            filterByMenu.style.width='450px';
            filterByMenu.style.right='-450px';
        }else{
            filterByMenu.style.width='450px';
            filterByMenu.style.right='0';
        }
    }

    onHideActionButtons = (event, rowId) =>{
        let dropdown     = document.getElementById('dropdown-event-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-event-'+rowId);
        dropdown.classList.remove('show');
        dropdownMenu.classList.remove('show');
        this.setState({activeRowId:0});
    }

    onModalFormReset = ()  =>{
    }

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:'',toastSuccess:false});
    } 

    onStarRatingChange = () =>{
    }

    setToasterState(isEnabled,message,isSucces,isAutoHide=true){
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        if(isAutoHide){
            setTimeout(()=> {
                this.onCloseToast();
            }, 4000);
        }else{
            setTimeout(()=> {
                this.onCloseToast();
            }, 10000);
        } 
    }  

    componentDidUpdate(prevProps){
        const {subactivity,errorData,shiftScheduleData,totalPage,scheduleCrewList,scheduleSkillList,requestedCrewData,crewCount,status,isFilterOn,unallocatedShiftsCountData} = this.props;
        const {activePage,hasMore,crewList, shiftSearch} = this.state;
        if (isFilterOn !== prevProps.isFilterOn) {
            this.inputFilter.click();   
        }else if(subactivity && subactivity !== prevProps.subactivity) {
            let arrResp = subactivity.split('~~'); 
            let actString = arrResp[0]; 
            if(actString===types.UNALLOCATED_SHIFTS_COUNT_SUCCESS){  
                let unallocatedShiftsCount = 0; 
                if(unallocatedShiftsCountData && unallocatedShiftsCountData.unallocated_shift_count) {
                    unallocatedShiftsCount = unallocatedShiftsCountData.unallocated_shift_count; 
                }
                this.setState({unallocatedShifts:unallocatedShiftsCount});    
            }
            else if(actString===types.SHIFT_SCHEDULE_LIST_SUCCESS){      
                let shifts = shiftScheduleData.shift_set.filter(str => str.title.toLowerCase().includes(shiftSearch));          
                this.setState({shiftList:shifts,totalCrewCount:crewCount}, () => {
                    let allShifts = shifts; 
                    let newSelectedShiftList = []; 
                    let newSelectedShiftIds = []; 
                    let selectedShiftList = this.state.selectedShiftList;
                    let selectedShiftIds = this.state.selectedShiftIds;

                    allShifts.forEach(item => {
                        if(Number(item.chiefs_pending)===0 && Number(item.pending)===0 ) {
                            newSelectedShiftList = selectedShiftList.filter(shiftItem => shiftItem.shift !== item.shift_id);
                            newSelectedShiftIds = selectedShiftIds.filter(shiftItem => shiftItem.shift !== item.shift_id);
                            selectedShiftList = newSelectedShiftList; 
                            selectedShiftIds = newSelectedShiftIds; 
                        }
                    })
                    if(this.state.selectedShiftList.length===0) {
                        this.setState({selectedShiftList,selectedShiftIds,crewList:[],selectedSkill:0,skillList:[]});
                    }
                    else {
                        this.setState({selectedShiftList,selectedShiftIds}, () => {
                            this.findCrew(); 
                        });
                    }
                    
                });
            }else if(actString===types.SCHEDULE_SHIFT_CREW_SUCCESS){ 
                // IF SKILL CHANGED FROM DROPDOWN, SKILL ARRAY NOT RETURNED 
                if(Array.isArray(scheduleSkillList) && scheduleSkillList.length > 0) {
                    this.setState({crewList:scheduleCrewList,skillList:scheduleSkillList,totalCrewCount:crewCount});
                }
                else {
                    this.setState({crewList:scheduleCrewList,totalCrewCount:crewCount});
                }
                this.setState({hasMore: (Number(crewCount)>Number(scheduleCrewList.length)), errorMessage:Number(crewCount)===0?MSG_CREW_SHIFT_NOT_FOUND:MSG_DEFAULT_CREW_LIST});                            
            }else if(actString===types.SHIFT_SCHEDULE_CREW_SEND_REQUEST_SUCCESS){
                let msgCrewAdd = LBL_CREW + " '"+requestedCrewData.requestedCrewName+"' added to shift(s) "+requestedCrewData.requestedShift.toString()+" with skill set '"+requestedCrewData.requestedSkillName+"'.";
                this.setToasterState(true,msgCrewAdd,true,false);
                this.findMoreCrew(true);
                this.props.shiftScheduleListAction(this.props.match.params.id);
                this.props.getUnallocatedShiftsCountAction(UNALLOCATED_SHIFTS_COUNT_DAYS);
            }else if(actString===types.SHIFT_SCHEDULE_CREW_SEND_REQUEST_ERROR){
                let userGroupData = userGroupUrlCheck(this.props.location);
                let lblChiefFilled = ''; 
                let lblChiefSkillFilled = '';  
                if(userGroupData!==undefined){
                    lblChiefFilled = stringFormat(MSG_CHIEF_FILLED,userGroupData.supervisor_name); 
                    lblChiefSkillFilled = stringFormat(MSG_CHIEF_SKILL_FILLED,userGroupData.supervisor_name); 
                }
                if(status===203){
                    if(errorData.hasOwnProperty('message')){
                        let errorMsg = errorData.message;
                        if(errorMsg===SHIFT_STAFF_REQ_ERR_UNAVAIL){
                            this.setToasterState(true,MSG_CREW_UNAVAILABLE,false);
                        }else if(errorMsg===SHIFT_STAFF_REQ_ERR_REQUESTED){
                            this.setToasterState(true,MSG_CREW_REQUESTED,false);
                        }else if(errorMsg===SHIFT_STAFF_REQ_ERR_FILLED){
                            this.setToasterState(true,MSG_CREW_FILLED,false);
                        }else if(errorMsg===SHIFT_STAFF_REQ_ERR_SKILL_FILLED){
                            this.setToasterState(true,MSG_CREW_SKILL_FILLED,false);
                        }else if(errorMsg===SHIFT_STAFF_REQ_ERR_CHEIF_FILLED){
                            this.setToasterState(true,lblChiefFilled,false);
                        }else if(errorMsg===SHIFT_STAFF_REQ_ERR_CHEIF_SKILL_FILLED){
                            this.setToasterState(true,lblChiefSkillFilled,false);
                        }else if(errorMsg===SHIFT_STAFF_REQ_ERR_DEPT_MISMATCH){
                            this.setToasterState(true,MSG_SHIFT_CREW_DEPT_MISMATCH,false);
                        } 
                    }
                }else{
                    this.setToasterState(true,errorData.hasOwnProperty('message') ? errorData.message : JSON.stringify(errorData),false);
                }              
            }
        }
    }

    componentDidMount() {
        const { location,selectedShiftDetails } = this.props;

        let userGroupData = userGroupUrlCheck(location);
        let userGroup = '';
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }   
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            document.body.classList.add('body-affiliate'); 
        }else if(userGroup===LOGIN_CLIENT_GROUP){
            document.body.classList.add('body-client'); 
        }

        this.props.shiftScheduleListAction(this.props.match.params.id);
        this.props.getUnallocatedShiftsCountAction(UNALLOCATED_SHIFTS_COUNT_DAYS); 

        document.title = LBL_APP_NAME+" - "+LBL_SCHEDULE_SHIFT; 

        if(selectedShiftDetails.length>0){ // when shift selection comes from outside schedule shift page. for ex, event summary
            const {selectedShiftList} = this.state;
            let allChecked = false;
            selectedShiftDetails.forEach(item => {
                
                let dateTime = [];
                dateTime.push(item.start_datetime,item.end_datetime);
                let isAddSchedule = checkPermissions("schedule","modify");
                selectedShiftList.push({
                    shift:item.shiftId,
                    dateTime:dateTime,                   
                    isDisableAddCrewBtn:isAddSchedule?showAddCrewBtn(item.status):false,
                    depts:item.department
                });
                if(item.isAllChecked){ // all checked to get selected
                    allChecked = true;
                }
            });       
            let shiftIds  = selectedShiftList.map(function(item) { return item.shift; });  // to check shift id selected from event summary/shift list page   
            let dptIds       = selectedShiftList.map(({ depts }) => depts).filter(d=>d!=='');
            let multi_shift  = shiftIds.length > 1 ? 1 : 0; 
            this.props.clearShiftIdsForScheduleAction();  
            this.setState({isFindCrewActive:true,selectedShiftIds:shiftIds,allChecked:allChecked,departments:dptIds,multi_shift:multi_shift}, () => {
                this.findCrew(); 
            });  
        }
    }

    goToShifts(e) {
        let route_url =  ROUTE_AFFILIATE_SHIFT;
        this.props.history.push(route_url);
    }

    onSortBy(e){
         let value = e.target.value;
         this.setState({sortBy:value},() =>{this.findCrew()})
    }

    render(){
        
        const {shiftScheduleData,status} = this.props;   
        let {selectedShiftIds,shiftList,showOnlyChief,crewList,isFindCrewActive,toastMessage,toastFlag,toastSuccess,hasMore,errorMessage,rand,allChecked,showAddCrewButton,totalCrewCount,selectedSkill,applyFilter, multi_shift} = this.state;         
          
        const dropdownSkills = this.dropdownSkills();  

        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = '';
        let supervisor_name = ''; 
        let lblChief = LBL_CHIEF;
        let lblCrew = 'Staff';
        if(userGroupData!==undefined){
           userGroup = userGroupData.user_group;
           supervisor_name = userGroupData.supervisor_name+' (s)' 
           lblChief = userGroupData.supervisor_name;
           if(userGroupData.staff_name){
            lblCrew = userGroupData.staff_name; 
         }
        }

        if(!supervisor_name){
            supervisor_name = LBL_CHIEF_S;
        }

        if(status===401 || status===403){
            if(userGroup===LOGIN_AFFILIATE_GROUP){
                return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
            }else{
                return <Redirect to={ROUTE_REFRESH} />;
            }
        }
        let timeZone = getUserTimeZone(this.props.location);

        let eventTitle = shiftScheduleData.title;
        let eventId    = shiftScheduleData.event_id;
        let eventRoute = eventRouteRedirect(shiftScheduleData.status);
        let location = '';
        if(shiftScheduleData.hasOwnProperty('location')){
            location = shiftScheduleData.location.location.location;
        }
        let shiftCount = 0;
        if(shiftScheduleData.hasOwnProperty('shift_set')){
            shiftCount = shiftScheduleData.shift_set.length;
        }

        let startDateTime = converDateToLocal(shiftScheduleData.start_date,timeZone.utc_offset,'ddmmyyyyhhmm'); 
        let endDateTime = converDateToLocal(shiftScheduleData.end_date,timeZone.utc_offset,'ddmmyyyyhhmm');

        let imgUserAdd = require('../../'+URL_IMG+'icon-user-add.png');

        let findCrewBtn = <><span>{LBL_SCHEDULE_SHIFT_FIND_CREW}</span></>; 

        return(
            <>
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />

                <div className="col-md-12">
                    <div className="box col-md-10 div-left-inline">                       
                        <div className="box-head">
                            <div className="shift-head">
                                <div className="shift-head__title">
                                    <h3><Link to="#" onClick={e => this.gotoEvents(eventRoute,eventId)}>{/*<i className="las la-arrow-left"></i>*/}</Link><span className="">{eventTitle}</span><span className="badge badge-pill badge-primary shift-count">{LBL_ACTIVE_SHIFTS} - {shiftCount}</span></h3>
                                    <p>
                                        <span className="shift-head__loc">
                                            <i className="fas fa-map-marker-alt"></i><span>{location}</span>
                                        </span>
                                        {/* <span className="shift-head__date">
                                            <i className="fas fa-calendar-alt"></i><span>{startDateTime} {LBL_TO.toLowerCase()}</span><i className="fas fa-calendar-alt"></i><span>{endDateTime}</span>
                                        </span> */}
                                    </p>
                                </div> 
                                <div className="shift-head__options">
                                    <div className="checkbox-wrapper">
                                        <div className="custom-radio">
                                            <input type="radio" id="radio1" name="radio" defaultChecked="checked" onChange={(e) => this.onChangePool(e,0)} />
                                            <label className="radio" htmlFor="radio1"></label>
                                            <label className="labeltext" htmlFor="radio1">{LBL_AFFILIATE_POOL}</label>
                                        </div>
                                        <div className="custom-radio">
                                            <input type="radio" id="radio2" name="radio" onChange={(e) => this.onChangePool(e,1)} />
                                            <label className="radio" htmlFor="radio2"></label>
                                            <label className="labeltext" htmlFor="radio2">{ LBL_OMNU_POOL}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="box col-md-2 div-right-inline">
                        <div className="box-head-schedule">
                            <div className="spanPointer" onClick={(e) => this.goToShifts(e)} >
                                    <div className="dash-row align-items-center">
                                        <div className="dash-card-number">
                                            <span className="h3 mb-0 text-red">
                                              {this.state.unallocatedShifts} 
                                            </span> 
                                        </div>
                                        <div className="dash-card-text h6 mb-2 p_text_color">
                                            <div>
                                                {LBL_UNALLOCATED_SHIFT} 
                                                <div><small className="p_text_color">({LBL_WITHIN_30_DAYS})</small></div>
                                            </div>
                                        </div>
                                        <div className="dash-card-symbol-schedule">
                                          <span className="circle-info-schedule blueRibbon-schedule"><i className="fas fa-ban"></i></span>
                                        </div>
                                    </div>
                                {/* <div className="card-body"></div> */}
                            </div>
                        </div>
                    </div> 
                </div>    
                <div className="col-md-12 mt-3">
                    <div className="row">
                        <div className="col-xl-4 col-md-6 pr-0">
                            <div className="box">
                                <div className="box-head box-head--shiftlist">                                
                                    <div className="custom-checkbox"><input type="checkbox" id="checkAll" onChange={(e) => this.onHandleAllChecked(e)} checked={allChecked}/><label className="checkbox" htmlFor="checkAll" /></div>
                                    <span className="shift-total">{shiftCount} {LBL_SHIFTS}</span>                          
                                    <div className="to-right">
                                        <div className="dataTables_filter">
                                            <label>
                                            <input type="search" className="" placeholder="Search Shift" id="shift-search-input" onChange={this.onSearchShift} />
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                { shiftList.map((item, index)  => {
                                    let shiftSkills = item.shift_skills;
                                    let locStartDate = converDateToLocal(item.start_datetime,timeZone.utc_offset,'ddmmyyyyhhmm'); 
                                    let locEndDate = converDateToLocal(item.end_datetime,timeZone.utc_offset,'ddmmyyyyhhmm'); 
                                    let shiftLength = convertDecimalToHHMM(item.shift_length); 
                                    return(
                                        <div className="shift-module" key={index}>
                                            <div className="custom-checkbox">
                                                {item.required>0 && item.pending>0 &&  <input type="checkbox" id={`check${item.shift_id}`} name="shiftId" 
                                                onChange={(e) => this.onHandleCheckedShift(e, item)} 
                                                checked={item.pending>0 && item.required>0?selectedShiftIds.includes(item.shift_id):false}
                                                />}  
                                                {(item.required===0 || item.pending===0) &&  <input type="checkbox" id={`check${item.shift_id}`} name="shiftId" 
                                                checked={item.pending>0 && item.required>0?selectedShiftIds.includes(item.shift_id):false} readOnly 
                                                />}
                                                <label className={item.pending>0 && item.required>0?' checkbox':'checkbox-disabled checkbox'} htmlFor={`check${item.shift_id}`}></label>
                                            </div>
                                            <div className="shift-module__wrap">
                                                <div className="shift-module__descs">
                                                    <h3><Link to="#" onClick={(e) => this.showShiftDetail(item.shift_id)}><span className="change-count color-red text-bold ">{item.special_shift?"! ":""}</span>{item.title}</Link>{item.department_name?' / '+item.department_name:''}</h3>
                                                    <div className="crew-block">
                                                        <h5><i className="far fa-clock"></i><span>{locStartDate} - {locEndDate}  ({shiftLength+' '+LBL_HOURS_SHORT.toLowerCase()})</span></h5>
                                                        <div className="shift-module__list">
                                                            <span className="crew-txt">{LBL_TOTAL} : <b>{item.required}</b></span>
                                                        </div>
                                                        <div className="shift-module__list">
                                                            <span className="crew-txt">{LBL_CONFIRMED} : <b>{parseInt(item.required,10)-parseInt(item.pending,10)}</b></span>
                                                            <span className="crew-txt">{LBL_REQUESTED} : <b>{item.requested}</b></span>
                                                            <span className={item.pending>0?'crew-txt crew-txt--pending':'crew-txt'}>{LBL_REQUIRED} : <b>{item.pending}</b></span>
                                                        </div>

                                                    </div>
                                                    <div className="crew-log">
                                                        { item.chiefs_required!==0 &&

                                                        <OverlayTrigger
                                                        placement="top"
                                                        delay={{ show: 450, hide: 250 }}
                                                        overlay={<Tooltip id='chief-tooltip' style={{
                                                            opacity: 0.8,
                                                        }}>
                                                        { LBL_CONFIRMED+': '+(parseInt(item.chiefs_required,10)-parseInt(item.chiefs_pending,10))+' '+LBL_REQUESTED+': '+item.chiefs_requested+' '+LBL_REQUIRED+': '+item.chiefs_pending }
                                                        </Tooltip>}
                                                        >
                                                        <p>                                                       
                                                            <span><img className='cheifimg-icon' src={require('../../'+ URL_IMG +'cheif.svg')}/>{supervisor_name}</span>
                                                            <span className={item.chiefs_required > (item.chiefs_requested-item.chiefs_rejected) && item.chiefs_pending>0?'crew---pending':(item.chiefs_pending===0? 'crew-label' : 'crew---filled')}>
                                                                {
                                                                (parseInt(item.chiefs_required,10)-parseInt(item.chiefs_pending,10))+' : '+item.chiefs_requested+' : '+item.chiefs_pending
                                                                }
                                                            </span>
                                                        </p>
                                                        </OverlayTrigger>
                                                      
                                                        }
                                                        { shiftSkills.map((skill, index)  => {
                                                            if(parseInt(skill.required,10) > 0) { 
                                                                let crew_rejected = skill.rejected - skill.chiefs_rejected;
                                                            return(
                                                                <OverlayTrigger key={index} placement="top" delay={{ show: 450, hide: 250 }}
                                                                overlay={<Tooltip id={index+'-tooltip'} style={{
                                                                    opacity: 0.8,
                                                                }}>
                                                                    { LBL_CONFIRMED+': '+(parseInt(skill.required,10)-parseInt(skill.pending,10))+' '+LBL_REQUESTED+': '+skill.requested+' '+LBL_REQUIRED+': '+skill.pending }
                                                                </Tooltip>}
                                                                >
                                                                <p id={index}>
                                                                    <span>{skill.skill_icon.length > 0 && <i className={"fas "+skill.skill_icon}></i> } {skill.skill_name} </span>

                                                                    <span className={skill.required > (skill.requested - crew_rejected) && skill.pending>0?'crew---pending':(skill.pending===0? 'crew-label' : 'crew---filled')}>{
                                                                        (parseInt(skill.required,10)-parseInt(skill.pending,10))+' : '+skill.requested+' : '+Number(skill.pending)
                                                                    }</span>
                                                                </p> 
                                                                </OverlayTrigger>
                                                            )
                                                            }
                                                            else {
                                                                return ''; 
                                                            }
                                                        })
                                                        }                                                    
                                                      
                                                    </div>
                                                </div>                                               
                                            </div>
                                        </div>
                                       
                                    )
                                })
                                }                           
                            </div>
                        </div>
                        <div className="col-xl-8 col-md-6">
                            <div className="box margin-bottom-20">
                                <div className="box-head box-head--crewlist">
                                    <div className="row mr-0 ml-0">
                                        <div className="col-md-3 float-left">
                                            <div className="row ml-0">                                            
                                                <div>
                                                    { totalCrewCount>=0 && <h3>{LBL_CREWS} ({totalCrewCount})</h3>}                                                       
                                                </div>
                                                <div className="mr-3">
                                                    <div  className={applyFilter ? 'filter-btn-wrapper  text-primary-filter':'filter-btn-wrapper text-primary'}>
                                                        <OverlayTrigger
                                                            placement="top"
                                                            delay={{ show: 450, hide: 250 }}
                                                            overlay={<Tooltip id="filterIcon-tooltip" style={{
                                                                opacity: 0.4,
                                                            }}>
                                                            Filter
                                                        </Tooltip>}
                                                        >
                                                            <button id="filterIcon" ref={input => this.inputFilter = input} onClick={this.onShowFilterBy} className={applyFilter ? 'filter-btn  text-primary-filter padding-5':'filter-btn text-primary padding-5'}><i className="las la-filter"></i></button>
                                                            
                                                        </OverlayTrigger>
                                                        
                                                    </div>                                                     
                                                </div>   
                                                {applyFilter > 0 && 
                                                    <div className="text-12 display-content" onClick={this.onResetFiltersButton} ><Link to="#" >{LBL_CLEAR_FILTERS}</Link></div>
                                                }  

                                                <div className="float-left padding-left-10 custom-checkbox paddingTop5">
                                                    {(selectedShiftIds && selectedShiftIds.length > 1) && 
                                                        <><input type="checkbox" checked={multi_shift > 0 ? true : false} name="multi_shift" id="multi_shift" value={multi_shift}  onClick={e => this.changeMultiSkill(e)} /><label className="checkbox" htmlFor="multi_shift" /> &nbsp;<label className="checkbox" htmlFor="multi_shift" >{LBL_MULTI_SHIFT}</label></>
                                                    }
                                                    {(!selectedShiftIds ||  selectedShiftIds.length <= 1) && 
                                                        <><input type="checkbox" checked={false} name="multi_shift" id="multi_shift" value='0' readOnly  disabled={true} className="text-muted" /><label className="checkbox" htmlFor="multi_shift" disabled={true} style={{"backgroundColor": "#dddddd"}} /> &nbsp;<label className="checkbox text-disabled" htmlFor="multi_shift" >{LBL_MULTI_SHIFT}</label></>
                                                    }
                                                </div>
                                            </div>                                       
                                        </div>
                                        
                                        <div className="col-md-9">                                             
                                            <div className="row float-right ml-0 mr-0">
                                                <div className="form-group select-input schedule-skill mr-3">
                                                    <select onChange={this.onSkillChange.bind(this)} name="skills">
                                                        <option value="0">{LBL_ALL_COMMON_SKILLS}</option>
                                                        {dropdownSkills.map((option, index) => {
                                                            let isChief = 0;
                                                            if(option.hasOwnProperty('isChief')){
                                                                isChief = option.isChief
                                                            }
                                                            if(selectedSkill===option.id && isChief===showOnlyChief){
                                                                return(
                                                                    <option key={index} value={option.id} data-chief={option.isChief?1:0} selected>{option.name}</option>
                                                                )
                                                            }else{
                                                                return(
                                                                    <option key={index} value={option.id} data-chief={option.isChief?1:0}>{option.name}</option>
                                                                )
                                                            }                                                      
                                                        })
                                                        }
                                                    </select>  
                                                </div> 
                                                <div className="row float-right ml-0 mr-0">
                                                    <div className="form-group select-input schedule-skill mr-3">
                                                        <select onChange={this.onSortBy.bind(this)} name="skills">
                                                            <option value="hours">{LBL_SORT_BY_HOURS}</option>
                                                            <option value="crew">{stringFormat(LBL_SORT_BY_CREW,lblCrew)}</option>
                                                            
                                                        </select>  
                                                    </div>                                                
                                                </div> 
                                                <div className="btn-group btn-group-sm to-right toggle-view padding-right-15">
                                                      <OverlayTrigger
                                                          placement="top"
                                                          delay={{ show: 450, hide: 250 }}
                                                          overlay={<Tooltip id="list-tooltip" style={{
                                                              opacity: 0.4,
                                                            }}>
                                                          {LBL_ASCENDING_ORDER}
                                                      </Tooltip>}
                                                      > 
                                                          <Link className={this.state.ascending?'btn btn-outline-primary margin-left-0 active':'btn btn-outline-primary margin-left-0'} to="#" onClick={(e) =>this.onSortToggle(true)}>
                                                          <i className="las la-sort-up"></i> </Link>
                                                      </OverlayTrigger>
                                                      <OverlayTrigger
                                                          placement="top"
                                                          delay={{ show: 450, hide: 250 }}
                                                          overlay={<Tooltip id="calendar-tooltip" style={{
                                                              opacity: 0.4,
                                                            }}>
                                                          {LBL_DESCENDING_ORDER} 
                                                      </Tooltip>}
                                                      >
                                                          <Link className={!this.state.ascending?'btn btn-outline-primary margin-left-0 active':'btn btn-outline-primary margin-left-0'} to="#" onClick={(e) =>this.onSortToggle(false)}>
                                                          <i className="las la-sort-down"></i>  </Link>
                                                      </OverlayTrigger>
                                                </div>                                               
                                                <div className="dataTables_filter">
                                                    <label>
                                                        <input type="search" className="search-sche-shift" placeholder="Search Crew Name" id="crew-search-input" name="searchCrew" onChange={this.onSearchCrew}/>
                                                    </label>
                                                </div>                                               
                                            </div>  
                                        </div>                                                                      
                                    </div>
                                </div>
                                <div className="box-content box-content--crewfilter">
                                </div>
                                <div className={crewList.length <=0?'col-md-12 pl-0 pr-0 bg-white':'schedule-crew-list col-md-12 pl-0 pr-0 bg-white'}>                            
                                    {
                                        errorMessage && crewList.length <=0 &&
                                        <div className="crew-list__noitem text-red">{errorMessage==='nocrews'?findCrewBtn:errorMessage}</div>
                                    }


                                    { crewList.map((crew, index)  => {
                                        // let skills = crew.crewskills_set;

                                        // let crewSkills = [];
                                        // skills.forEach(el=>{ // using crew skill's build the Skill and Chief - Skill array
                                        //     crewSkills.push({skill_id:el.skill_id,skill_name:el.skill_name,isChief:0});
                                        //     if(crew.chief_eligibility){ 
                                        //         // crewSkills.push({skill_id:el.skill_id,skill_name:'Chief - '+el.skill_name,isChief:1})
                                        //         crewSkills.push({skill_id:el.skill_id,skill_name:userGroupData.supervisor_name+' - '+el.skill_name,isChief:1})
                                        //     }                                            
                                        // });
                                        
                                        // let skillStr = ''; 
                                        // let crewSkillDropdown = []; // for crew dropdown on add crew button
                                        // crewSkills.forEach(skill =>{  // compare the crewSkills array with the dropdown skills and retain the matching skills only 
                                        //     if(dropdownSkills.some(ele => ele.name === skill.skill_name)){
                                        //         skillStr += skill.skill_name+', '; 
                                        //         crewSkillDropdown.push({skill_id:skill.skill_id,skill_name:skill.skill_name,isChief:skill.isChief});
                                        //     }
                                        // });   

                                        // CREW SKILL DROPWORN OPTIONS ARE COMING FROM SERVER, JUST FORMAT IT FOR CHIEF SYMBOL AND ALSO CREATE SKILL STRING - 14 Dec 2020
                                        let skillStr = '', skillName = ''; 
                                        let arrSkillNames = [], crewSkillDropdown = [];
                                        let isChief = 0; 
                                        if(crew.skills_dropdown && Array.isArray(crew.skills_dropdown) && crew.skills_dropdown.length > 0) { 
                                            crew.skills_dropdown.forEach(skill =>{ 
                                                if(String(skill.chief_eligibility)==='true'){
                                                    isChief = 1;  
                                                    skillName = lblChief+' - '+skill.skill_name; 
                                                }
                                                else {
                                                    isChief = 0;  
                                                    skillName = skill.skill_name;
                                                }
                                                crewSkillDropdown.push({skill_id:skill.skill_id,skill_name:skillName,isChief:Number(isChief)});
                                                if(!arrSkillNames.includes(skill.skill_name)) {
                                                    arrSkillNames.push(skill.skill_name);  
                                                    skillStr += skill.skill_name+', ';
                                                }
                                            });   
                                        }
                                        
                                        let crewProfileId = crew.profile_id;
                                        let imageClass = crew.chief_eligibility?'img-fluid img-prof-small img-crew-chief':'img-fluid img-prof-small';

                                        let profileImgTag = <img className={imageClass} src={require('../../'+URL_IMG+'crew-icon.jpg')} alt={crew.user.first_name} title={crew.user.first_name} />;

                                        if ((crew.crew_profile_picture) && crew.crew_profile_picture.trim().length > 0){
                                            profileImgTag = <img className={imageClass} src={crew.crew_profile_picture} alt={crew.user.first_name} title={crew.user.first_name} />;
                                        }else if(((!crew.crew_profile_picture) || crew.crew_profile_picture.trim().length===0) && crew.avatar_name && crew.avatar_name.trim().length > 0){
                                          
                                            profileImgTag = <div title={crew.user.first_name+' '+crew.user.last_name} className={crew.chief_eligibility?'center-align img-fluid img-prof-small img-avatar img-crew-chief':'center-align img-fluid img-prof-small img-avatar'} style={{ background:crew.profile_color}}>{crew.avatar_name}</div>; 
                                        }

                                        const chiefIcon = crew.chief_eligibility? <span><img className='cheifimg-icon' src={require('../../'+ URL_IMG +'cheif.svg')}></img></span>:'';
                                        let crewRating = crew.crew_total_rating;

                                        let department = crew.department.length>0?crew.department.map(e => e.name).join(",\r"):''

                                        return(
                                            <div className="s-crew-border" key={index}>
                                                <div className="row">
                                                    <div className="rightAlign padding-right-20" >
                                                        <OverlayTrigger
                                                            placement="top"
                                                            delay={{ show: 450, hide: 250 }}
                                                            overlay={<Tooltip id="filterIcon-tooltip" style={{
                                                                opacity: 0.4,
                                                            }}>
                                                            {LBL_WORKING_HRS_DESC}
                                                        </Tooltip>}
                                                        >
                                                            <span className="badge badge-pill badge-primary shift-count">{convertDecimalToHHMM(crew.thirty_days)}</span>
                                                        </OverlayTrigger>
                                                    </div>
                                                </div>
                                                <div className="crew minHeight125">
                                                    <div className="crew__aside">
                                                        <div className="crew__thumb">
                                                            {profileImgTag}
                                                        </div>
                                                        <span className="crew__badge font__size__12">{crew.omnu_points}</span>
                                                        <div className="crew__rating rating-display-only">
                                                            {CREW_MAX_RATING.map(ratingNum => {
                                                                if(Number(ratingNum) <= crewRating) {
                                                                    return(
                                                                    <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"rating"+ratingNum}  data-id={ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="fas fa-star"></i></label></React.Fragment>
                                                                )
                                                                }else{
                                                                    if(parseFloat(ratingNum)-0.5===parseFloat(crewRating)){
                                                                        return(
                                                                            <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="fas fa-star-half-alt"></i></label></React.Fragment>
                                                                        )
                                                                    }else{
                                                                        return(
                                                                            <React.Fragment key={'rating'+ratingNum}><input type="checkbox" checked={false} name="rating" id={"rating"+ratingNum} disabled={true} /><label htmlFor={"rating"+ratingNum}><i className="far fa-star"></i></label></React.Fragment>
                                                                        )
                                                                    } 
                                                                }                                  
                                                            })
                                                            }
                                                        </div>
                                                        <div className='d-flex align-items-center'>
                                                            {crew.has_vehicle&&<span className="chief-icon background-black"><img className="car-image" src={require('../../'+URL_IMG+'car_filled.svg')} alt="Action" /></span>} {crew.drive_to_shift_location && <i class="fas fa-solid fa-id-card mr-2 "></i>}
                                                        </div>
                                                    </div>
                                                    <div className="crew__content">
                                                        <div className="crew__desc">
                                                            {/* <div className="row paddingLeft15 mb-0 padding-Bottom-5">
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    delay={{ show: 450, hide: 250 }}
                                                                    overlay={<Tooltip id="filterIcon-tooltip" style={{
                                                                        opacity: 0.4,
                                                                    }}>
                                                                    {LBL_WORKING_HRS_DESC}
                                                                </Tooltip>}
                                                                >
                                                                    <span className="badge badge-pill badge-primary shift-count">{convertDecimalToHHMM(crew.thirty_days)}</span>
                                                                    
                                                                </OverlayTrigger>
                                                                <div className="col8 text14Bold paddingBottomp0 padding-left-5">{vehicleInfo}</div>
                                                                
                                                            </div> */}
                                                            <div className="row paddingLeft15 mb-0 paddingBottomp0">
                                                                <div className="col8 text14Bold paddingBottomp0 ">{chiefIcon}  <b>{crew.user.first_name+' '+crew.user.last_name}</b> <p className="paddingTop0 paddingBottomp0"><small>{crew.pay_level_name}</small></p>
                                                                </div>
                                                            </div>
                                                            <div className="row paddingLeft15 paddingTop5 text11 text-muted">{department}</div>
                                                            <div className="row paddingLeft15 mb-0 paddingBottomp0 display-block">
                                                            {crew.crewskills_set.map((skill, index)  => {
                                                                    return(
                                                                        <React.Fragment key={index}>
                                                                        <p className="mb-0"><small><i className={'fas '+ skill.skill_icon}></i> {skill.skill_name}</small></p>
                                                                        </React.Fragment>
                                                                    )
                                                                })
                                                                }
                                                            </div>
                                                            <div className="row">
                                                                {crew.prevoius_shifts.length > 0 &&
                                                                    crew.prevoius_shifts.map((p_shift,index) =>{
                                                                        return(
                                                                            <OverlayTrigger
                                                                                placement="bottom"
                                                                                delay={{ show: 450, hide: 250 }}
                                                                                overlay={<Tooltip id="filterIcon-tooltip" style={{
                                                                                    opacity: 0.4,
                                                                                }}>
                                                                                {p_shift.shift_title+' @ '+p_shift.event_title + ' ('+converDateToLocal(p_shift.start_time,timeZone.utc_offset,'ddmmyyyyhhmm')+')'}
                                                                            </Tooltip>}
                                                                            >
                                                                            <div className={"schedule_shift_box previous-shift"}>
                                                                                    <span className="badge"> {convertDecimalToHHMM(p_shift.shift_length)}</span>
                                                                            </div>
                                                                            </OverlayTrigger>
                                                                           
                                                                        )
                                                                    })  
                                                                }
                                                                {crew.upcoming_shift.shift_title &&
                                                                    <OverlayTrigger
                                                                        placement="bottom"
                                                                        delay={{ show: 450, hide: 250 }}
                                                                        overlay={<Tooltip id="filterIcon-tooltip" style={{
                                                                            opacity: 0.4,
                                                                        }}>
                                                                        {crew.upcoming_shift.shift_title+' @ '+crew.upcoming_shift.event_title + ' ('+converDateToLocal(crew.upcoming_shift.start_time,timeZone.utc_offset,'ddmmyyyyhhmm')+')'}
                                                                        </Tooltip>}
                                                                    >
                                                                        <div className={"schedule_shift_box"}>
                                                                            <span className="badge">{convertDecimalToHHMM(crew.upcoming_shift.shift_length)}</span>
                                                                        </div>
                                                                    </OverlayTrigger> 
                                                                }
                                                            </div>
                                                        </div> 
                                                        {showAddCrewButton && 
                                                        <div className="crew__button">
                                                            {
                                                            
                                                            (crewSkillDropdown.length>1) &&
                                                                                                               
                                                                <div className="add-crew dropdown" id={'dropdown-event-'+crewProfileId}>
                                                                    <button className="dropdown-toggle" type="button"
                                                                    id={'dropdownMenuButton-event-'+crewProfileId} data-toggle="dropdown"
                                                                    aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, crewProfileId)}
                                                                    onBlur={(e) => this.onHideActionButtons(e, crewProfileId)}
                                                                    >
                                                                        <img id="test" src={imgUserAdd} alt="Action" />
                                                                    </button>
                                                                    <div className="dropdown-menu" id={'dropdown-menu-event-'+crewProfileId}
                                                                        aria-labelledby={'dropdownMenuButton-event-'+crewProfileId}>
                                                                        {   crewSkillDropdown.map((sk, index)  => {
                                                                                return(
                                                                                   
                                                                                    <Link key={index}className="dropdown-item edit" to="#" onMouseDown={(e) => this.sendRequestToCrew(e, sk.skill_id,crewProfileId,sk.isChief)}> {sk.skill_name}</Link> 
                                                                                )
                                                                            })
                                                                        }  
                                                                                                                    
                                                                    </div>
                                                                </div>
                                                            }                                                
                                                                
                                                            {
                                                                crewSkillDropdown.length===1 &&
                                                           
                                                                <button className="btn-add" onClick={(e) => this.sendRequestToCrew(e, crewSkillDropdown[0].skill_id,crewProfileId,crewSkillDropdown[0].isChief)}><img src={imgUserAdd} alt="add crew"/></button>
                                                            }   
                                                        </div>
                                                        }
                                                    </div>
                                                </div>
                                                {/* <div>{JSON.stringify(showAddCrewButton)+' :: '+skillStr+JSON.stringify(crewSkills)}</div> */}

                                            </div>  
                                        )


                                    })

                                    }                                                                                
                                </div> 
                                {   hasMore &&
                                    <div className="loadmore-block">
                                        <Link to="#" onClick={(e) => this.findMoreCrew(false)} >View more</Link>
                                    </div>
                                }  
                            </div>
                        </div>
                    </div>
                </div>        
                <Filter isDetail={true} onResetFiltersButton={this.onResetFiltersButton} onApplyFilterButton={this.onApplyFilterButton}>
                    {/* sendAssociated ADDED ON 18 Nov 2020 - ON BACKEND TEAM SUGGESTION */}
                    <FilterSchedule {...this.state} applyFilters={this.applyFilters} sendAssociated="1" /> 
                    <ShiftDetailSlider location={this.props.location} {...this.state} hideEditDeleteAction='1' calledFrom="scheduleCrew" shiftScheduleListAction={this.props.shiftScheduleListAction} paramId={this.props.match.params.id} loadEventSchedule={this.loadEventSchedule} />
                </Filter>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {     
        status:state.event.status,
        subactivity:state.event.subactivity,
        activity:state.event.activity,
        errorData:state.event.errorData,       
        shiftScheduleData:state.event.shiftScheduleData,
        scheduleCrewList:state.event.scheduleCrewList,
        scheduleSkillList:state.event.scheduleSkillList,
        totalPage:state.event.scheduleCrewTotalPage,
        numRows:state.event.scheduleCrewNumRows,
        crewCount:state.event.scheduleCrewCount,
        requestedCrewData:state.event.requestedCrewData,
        selectedShiftDetails:state.event.selectedShiftDetails,
        isFilterOn: state.commons.isFilterOn,
        unallocatedShiftsCountData: state.event.unallocatedShiftsCountData,
    }
};
 
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({  
        shiftScheduleListAction:shiftScheduleListAction,
        shiftScheduleCrewAction:shiftScheduleCrewAction,
        scheduleShiftCrewAction:scheduleShiftCrewAction, 
        shiftScheduleCrewRequestAction:shiftScheduleCrewRequestAction,
        clearShiftIdsForScheduleAction:clearShiftIdsForScheduleAction,
        menuActiveAction:menuActiveAction,
        getUnallocatedShiftsCountAction:getUnallocatedShiftsCountAction,
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(Schedule);